import React, { Component } from "react";
import "./info.css";
import Next from "../assets/button/next.png";

class Info extends Component {
  state = {};

  render() {
    return (
      <div className="container Rectangle-Copy-2">
        <div className="text blk">Profile </div>
        <div className="text">Name</div>
        <div className="values">{this.props.name}</div>
        <div className="text">Date of Birth</div>
        <div className="values">{this.props.dob}</div>
        <div className="text">Email Address</div>
        <div className="values">{this.props.email}</div>
        <div className="text">Address</div>
        <div className="values">{this.props.address}</div>
        <div className="text">Gender</div>
        <div className="values">{this.props.gender}</div>
        <div className="text">Nationality</div>
        <div className="values">{this.props.nationality}</div>
        <div className="btns">
          <a href="/crypto/holdings?login=true">
            <img src={Next} alt="" className="img-fluid" />
          </a>
        </div>
      </div>
    );
  }
}

export default Info;
